<template>
  <div :id="uuid" :style="{ width: width + 'px', height: height + 'px' }" />
</template>

<script setup>
import { getDataJson, pollingRefresh, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
import cptFunnelOption from "@/components/echarts/attrs/cpt-chart-funnel-option";
import { onMounted, watch, computed} from "vue";
import * as echarts from 'echarts'

const props = defineProps({
  width: Number,
  height: Number,
  option: Object,
  show: Boolean,
  components: Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute, (obj) => {
    processData(props.option.cptDataForm, newData, jsFunFlag)
    loadChart(obj);
  }, { deep: true })
// watch(() => props.option.attribute, (obj) => {
//   processData(props.option.cptDataForm,newData,jsFunFlag)
//   loadChart(obj);
// }, { deep: true })
watch(() => [props.width, props.height], () => {
  chart.resize()
})
let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

//mark:合并属性，由于属性字段更新，导致旧版本数据不能正常渲染组件或配置表单，所有组件都应执行这项操作！！！
const temp = JSON.parse(JSON.stringify(cptFunnelOption.attribute))
props.option.attribute = Object.assign({}, temp, props.option.attribute);

onMounted(() => {
  const element = document.getElementById(uuid)
  if (!element) {
    return
  }
  console.log(element,'adsoijadjaisdji');
  chart = echarts.init(element)
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm, paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm, paras),
    props.components)
}
function loadData(cptDataForm, paras) {
  getDataJson(cptDataForm, paras, (res) => {
    // cptData = res;
    newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
    jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
    processData(cptDataForm, newData, jsFunFlag)
    loadChart(props.option.attribute);

  })
}
function processData(cptDataForm, res, jsFunFlag) {
  // 第一层判断 如果选择数据集
  if (cptDataForm.dataSource == '4') {
    // 第二层判断 ，如果没有配转换脚本
    if (jsFunFlag) { // 没有全部配置映射字段
      if (hasNonEmptyValues(props.option.attribute.cptTableData)) {
        const dataKey = props.option.attribute.cptTableData;
        let newarr = [];
        // 遍历原始数组并重组数据
        res.forEach(item => {
          let name = item[dataKey[0].value];
          let value = item[dataKey[1].value];
          // 创建新的对象并添加到 aa 数组中
          newarr.push({ name, value });
        });
        console.log(newarr, '新数组')
        cptData = newarr;
      }
    } else { // 如果配置了转换脚本
      cptData = res;
    }
  } else { // 不是数据集类型，是静态数据
    cptData = res;
  }
}
function loadChart(attr) {
  console.log(attr,'attrattrattr');
  if (!cptData) return;
  chartOption = {
    color: attr.color,
    title: attr.title,
    tooltip: {
      trigger: 'item',
      ...attr.tooltip,
    },
    legend: attr.legend,
    series: [
      {
        name: 'Funnel',
        type: 'funnel',
        orient: attr.series.orient,
        sort: attr.series.sort,
        gap: attr.series.gap,
        top: attr.series.top,
        bottom: attr.series.bottom,
        left: attr.series.left,
        right: attr.series.right,
        // label: attr.series.label,
        // label: {
        //   formatter: '{b}-${c}'
        // },
         label: { // --- 核心配置：标签 ---
          show: attr.series.label.show,
          position: 'inside', // 标签位置: 'inside' | 'left' | 'right' | ...
          formatter: '{b}: {c}',
          color: attr.series.label.color,
          fontSize: attr.series.label.fontSize
          // 标签内容格式器
          // {a}：系列名
          // {b}：数据名（如‘展现’）
          // {c}：数据值（如10000）
          // {d}：百分比（相对于总和的占比，非转化率）
          // 自定义函数：formatter: function(params) { ... }
        },
        labelLine: attr.series.labelLine,
        funnelAlign: attr.series.funnelAlign,
        itemStyle: {
          borderWidth: 0
        },
        data: cptData
      }
    ]
  }
  if (chart) {
    chart.setOption(chartOption, true);
    chart.on('click', (params) => {
      emit("clickHandler", props.option.interaction, 'default', params.name)
    })
  }
}

defineExpose({ refreshCptData })
</script>

<style scoped></style>
